goog.provide('el8.ptdata.model.orderSet');
goog.provide('el8.ptdata.model.orderSet.referral');

goog.require('el8.util.consts');
goog.require('el8.ptdata.model.order');
goog.require('el8.service.urls');

// ALL OF THESE DEPENDENCIES ARE DUE TO "DELETE"
//goog.require('el8.ptdata.*Orders');
//goog.require('el8.appchart.mainFeeds.chart');
//goog.require('el8.appchart.mainFeeds.reqAct');

// ---------------------------
// ORDER ENTITY SETS
// ---------------------------
(function() {

    // ----------------------
    // ORDER ENTITY SET
    // ----------------------
    var _class = function(spec) {
        spec = spec || {};
        el8_EntitySet.call(this, spec);
    };
    _class.inheritsFrom(el8_EntitySet);
    _class.prototype.allSigned = function() {
        var result = [];
        var all = this.all();
        for (var i=0; i< all.length; i++) {
            if (!all[i].isOnHold()) {
                result.push(all[i]);
            }
        }
        return result;
    };

    var orderCustomDeleteFn = function(item, _successCb, errorCb, opts) {
        var successCb = function(data) {
            if (data) {
                if (item.isSignedOff()) {
                    var orderType = item.getOrderType();
                    if (orderType === 'referral') {
                        el8.ptdata.allSignedReferralOrders.remove(item);
                    }
                    if (data['remove_visitnote_references']) {
                        el8.appchart.visitNote.main.removeNewOrder(item);
                    } else if (data['remove_nonvisitnote_references']) {
                        el8.appchart.nonvisitNote.main.removeNewOrder(item);
                    }
                }
            }
            if (_successCb) { _successCb(data); }
        };
        el8.ptdata.documentDeleteFn(item, successCb, errorCb, opts);
    };

    el8.ptdata.model.orderSet = function(type, initialSet) {
        var that = new _class({
            model: el8.ptdata.model.order[type],
            items: initialSet,
            deleteFn: orderCustomDeleteFn,
            urlFn: function(id) { return el8.service.urls.get('getLabOrderById', [id]); }
        });
        return that;
    };

    // ----------------------
    // REFERRAL ORDER ENTITY SET
    // ----------------------
    var _classReferral = function(spec) {
        spec = spec || {};
        _class.call(this, spec);
    };
    _classReferral.inheritsFrom(_class);
    _classReferral.prototype.latestOrdersBySpecialty = function(spec) {
        var includeOnHold = spec.includeOnHold || false;
        var items = this.all();
        var latestBySpecialty = {};
        var candidate = null;
        var currSpecialtyId = null;
        var noSpecialty = [];

        for( var i=0; i<items.length; i++ ) {
            candidate = items[i];
            if( !candidate.isOnHold() || includeOnHold ) {
                currSpecialtyId = candidate.getSpecialtyId();
                if( currSpecialtyId ) {
                    var currVal = latestBySpecialty[ currSpecialtyId ];
                    if( !currVal ) {
                        latestBySpecialty[ currSpecialtyId ] = candidate;
                    } else {
                        if( candidate.getDocumentDate() > currVal.getDocumentDate() ) {
                            latestBySpecialty[ currSpecialtyId ] = candidate;
                        }
                    }
                } else {
                    noSpecialty.push(candidate);
                }
            }
        }

        var result = [];
        for(var key in latestBySpecialty) {
            if (latestBySpecialty.hasOwnProperty(key)) {
                result.push( latestBySpecialty[ key ] );
            }
        }
        // Add all the orders with no specialty
        for( var i=0; i<noSpecialty.length; i++) {
            result.push(noSpecialty[i]);
        }
        var sortFn = function(a, b) {
            return b.getDocumentDate().getTime() - a.getDocumentDate().getTime();
        };
        return result.sort(sortFn);
    };
    _classReferral.prototype.bySpecialtyId = function(specialtyId) {
        function filterFunction(referralOrder, index, array) {
            return (specialtyId === referralOrder.getSpecialtyId());
        }
        return this.all().filter(filterFunction);
    };

    el8.ptdata.model.orderSet.referral = function(spec) {
        return new _classReferral({
            model: el8.ptdata.model.order.referral,
            deleteFn: orderCustomDeleteFn
        });
    };

})();



